import style from "./ExplanationBlock.module.scss";

export function ExplanationBlock() {
    return (
        <div className={style.container}>
            <p className={style.title}>Особливості мобільних проксі</p>
            <p className={style.desct}>Придбання серверного проксі надає користувачеві доступ до пулу українських IP-адресів, для передачі та отримання інформації без будь-яких обмежень.</p>
        </div>
    )
}